'use client'
import {
  Button,
  Card,
  Image,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'
import NextImage from 'next/image'

import {
  ButtonProps,
  ImageProps,
  NormalizedSection,
  ParagraphProps,
  TitleProps,
} from '@/types'

import Slider from '@/components/molecules/Slider'

export interface CardSliderProps extends NormalizedSection {
  modelledContent: {
    title: TitleProps
    paragraph: ParagraphProps
    cta: ButtonProps
    items: {
      title: TitleProps
      image: ImageProps
      cta: any
    }[]
  }
}

const CardSlider = ({ modelledContent }: CardSliderProps) => {
  const { title, paragraph, items, cta } = modelledContent

  const handleCtaClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (cta.onClick) cta.onClick(event)
  }

  return (
    <Section className='section-card-slider'>
      <div className='section-wrapper'>
        <div className='section-intro'>
          <div className='section-intro--content'>
            <Title
              {...title}
              dangerouslySetInnerHTML={{ __html: title.content || '' }}
            />
            <Paragraph
              as={'div'}
              dangerouslySetInnerHTML={{ __html: paragraph.content || '' }}
            />
            {!!cta.href && !!cta.content && (
              <Button
                animate
                as='a'
                {...cta}
                onClick={handleCtaClick}
              >
                {cta.content}
              </Button>
            )}
          </div>
        </div>
        {!!items && !!items.length && (
          <div className='section-content'>
            <Slider
              spaceBetween={16}
              slidesPerView='auto'
              slides={items.map((item, i) => {
                const { title, cta, image } = item
                const imageProps = {
                  src: image?.src || '',
                  alt: image?.alt || '',
                  width: image?.width || 360,
                  height: image?.height || 558,
                }

                const handleCtaClick = (
                  event: React.MouseEvent<HTMLButtonElement>
                ) => {
                  if (cta.onClick) cta.onClick(event)
                }

                return (
                  <div
                    key={'Card-slider' + i}
                    style={{ paddingBottom: 'var(--Spacing-M)' }}
                  >
                    <Card
                      className='Card-slider--element'
                      animate
                      variant='default'
                    >
                      <div>
                        <Button
                          animate
                          as='a'
                          {...cta}
                          size='small'
                          variant='negative'
                          onClick={handleCtaClick}
                        >
                          {/* `alt` attr already passed into imageProps */}
                          {/* eslint-disable-next-line jsx-a11y/alt-text */}
                          <Image
                            fit={image.fit}
                            as={NextImage}
                            className='Slider-image'
                            imageProps={imageProps}
                          />
                        </Button>
                        <Title
                          {...title}
                          dangerouslySetInnerHTML={{
                            __html: title.content || '',
                          }}
                        />
                      </div>
                    </Card>
                  </div>
                )
              })}
            />
          </div>
        )}
      </div>
    </Section>
  )
}

export default CardSlider
